import { GridColumnBodyLitRenderer, columnBodyRenderer } from '@vaadin/grid/lit.js';
import '@vaadin/grid/vaadin-grid-column.js';
import { html, nothing } from 'lit';

export type EdiAddenda = {
    item1: string;
    item2: string;
};

export type EdiTransactionItem = {
    ediDate: string;
    ediAddenda: EdiAddenda[];
    ediAmount: number;
};

const renderEdiDateColumn = (item: EdiTransactionItem) => {
    return html`<div class="flex flex-col">
        <div class="text-sm font-medium">${item.ediDate}</div>
    </div>`;
};

const renderEdiDescriptionColumn = (item: EdiTransactionItem) => {
    return html` <div class="flex flex-col">
        ${item.ediAddenda.map(
            item =>
                html`<div class="text-sm text-secondary">${item.item1}</div>
                    ${item.item2
                        ? html`<div class="text-sm text-secondary">${item.item2}</div>`
                        : nothing}`
        )}
    </div>`;
};

const renderEdiAmountColumn = (item: EdiTransactionItem) => {
    return html`<div class="flex flex-col">
        <div class="text-sm font-medium">${item.ediAmount}</div>
    </div>`;
};

export const ediReportColumns = () => {
    return html`<vaadin-grid-column
            ${columnBodyRenderer(
                renderEdiDateColumn as GridColumnBodyLitRenderer<EdiTransactionItem>
            )}
        ></vaadin-grid-column>
        <vaadin-grid-column
            ${columnBodyRenderer(
                renderEdiDescriptionColumn as GridColumnBodyLitRenderer<EdiTransactionItem>
            )}
        ></vaadin-grid-column>
        <vaadin-grid-column
            text-align="end"
            ${columnBodyRenderer(
                renderEdiAmountColumn as GridColumnBodyLitRenderer<EdiTransactionItem>
            )}
        ></vaadin-grid-column>`;
};
